<template>
    <router-link to="" @click.native="navigate">
        <span v-if="accessToken">{{ $t("common.로그아웃") }}</span>
        <span v-else>{{ $t("common.로그인") }}</span>
    </router-link>
</template>
<script>
export default {
    methods: {
        navigate(){
            if(this.accessToken){
                this.$store.dispatch("logout");
            }
            else{
                this.$router.push(`/login`);
            }
        }
    },
    computed: {
        accessToken(){
            return this.$store.state.accessToken;
        }
    }
}
</script>